const APIS = {
  USER: "usermanagementservice/api/user/",
  PERMISSION: "/permission/",
};

export default APIS;
